/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Upgrade_PlanInputs */

const es_admin_company_overview_upgrade_plan = /** @type {(inputs: Admin_Company_Overview_Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar plan`)
};

const en_admin_company_overview_upgrade_plan = /** @type {(inputs: Admin_Company_Overview_Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade plan`)
};

/**
* | output |
* | --- |
* | "Upgrade plan" |
*
* @param {Admin_Company_Overview_Upgrade_PlanInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_upgrade_plan = /** @type {((inputs?: Admin_Company_Overview_Upgrade_PlanInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Upgrade_PlanInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_upgrade_plan(inputs)
	return en_admin_company_overview_upgrade_plan(inputs)
});
export { admin_company_overview_upgrade_plan as "admin.company_overview.upgrade_plan" }